function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <p className="footer-text">© {year} Daffaa Aprilino</p>
    </footer>
  );
}

export default Footer;
